module.exports = __webpack_public_path__ + "static/media/setor64.3fe9ec72.png";